import Vue from 'vue'
import Router from 'vue-router'
import Floor from '@/components/floor/Floor'
import NewFloor from '@/components/floor/NewFloor'

Vue.use(Router)

export default new Router({
    base: process.env.BASE_URL,
    // 解决二级页面继承上一个页面滚动条的问题
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        // 基础页面
        {
            path: '/index',
            name: 'Index',
            components: {
                default: () => import(/* webpackChunkName: "index" */ '@/views/index/NewIndex.vue'),
                floor: Floor
            },
            meta: {
                title: '首页',
            }
        },
        //  新首页
        {
            path: '/',
            name: 'NewIndex',
            components: {
                default: () => import(/* webpackChunkName: "index" */ '@/views/index/NewIndex.vue'),
                floor: NewFloor
            },
            meta: {
                title: '首页',
            }
        },
        { // 微信配置的跳转地址，为了获取openId
            path: '/index/:openId',
            name: 'WechatIndex',
            components: {
                default: () => import(/* webpackChunkName: "index" */ '@/views/index/NewIndex.vue'),
                floor: NewFloor
            },
            meta: {
                title: '首页'
            }
        },
        // {
        //     path: '/registered',
        //     name: 'Registered',
        //     component: () => import(/* webpackChunkName: "registered" */ '@/views/join/registered/RegisteredValid.vue'),
        //     meta: {
        //         title: '注册'
        //     }
        // },
        // {
        //     path: '/registered-save/v2',
        //     name: 'Registered-v2',
        //     component: () => import(/* webpackChunkName: "registered" */ '@/views/join/registered/RegisteredSave.vue'),
        //     meta: {
        //         title: '注册'
        //     }
        // },
        {
            path: '/login',
            name: 'Login',
            component: () => import(/* webpackChunkName: "login" */ '@/views/signUp/Index.vue'),
            meta: {
                title: '登录'
            }
        },
        {
            path: '/forgetPassword',
            name: 'ForgetPassword',
            component: () => import(/* webpackChunkName: "forgetPassword" */ '@/views/join/forget-password/ForgetPassword1.vue'),
            meta: {
                title: '忘记密码'
            }
        },
        // 个人中心
        {
            path: '/userCenter',
            name: 'UserCenter',
            components: {
                default: () => import(/* webpackChunkName: "userCenter" */ '@/views/user/user-center/UserCenterNew.vue'),
                floor: NewFloor
            },
            meta: {
                title: '个人中心',
                requiresLogin: true,
            }
        },
        {
            path: '/setMyInformation',
            name: 'SetMyInformation',
            component: () => import(/* webpackChunkName: "setMyInformation" */ '@/views/user/set-my-information/SetMyInformation.vue'),
            meta: {
                title: '个人信息中心'
            }
        },
        {
            path: '/personInformation',
            name: 'PersonInformation',
            component: () => import(/* webpackChunkName: "personInformation" */ '@/views/user/set-my-information/PersonInformation.vue'),
            meta: {
                title: '基本信息'
            }
        },
        {
            path: '/changePhoneNumber',
            name: 'ChangePhoneNumber',
            component: () => import(/* webpackChunkName: "changePhoneNumber" */ '@/views/user/set-my-information/ChangePhoneNumber.vue'),
            meta: {
                title: '号码变更'
            }
        },
        {
            path: '/changePassword',
            name: 'ChangePassword',
            component: () => import(/* webpackChunkName: "changePassword" */ '@/views/user/set-my-information/ChangePassword.vue'),
            meta: {
                title: '修改密码'
            }
        },
        {
            path: '/carBindingList',
            name: 'CarBindingList',
            component: () => import(/* webpackChunkName: "carBindingList" */ '@/views/user/set-my-information/car-binding/CarBindingList.vue'),
            meta: {
                title: '车辆绑定列表'
            }
        },
        {
            path: '/addCarBainding',
            name: 'AddCarBainding',
            component: () => import(/* webpackChunkName: "addCarBainding" */ '@/views/user/set-my-information/car-binding/AddCarBainding.vue'),
            meta: {
                title: '车辆绑定'
            }
        },
        {
            path: '/driverLicenseBinding',
            name: 'DriverLicenseBinding',
            component: () => import(/* webpackChunkName: "driverLicenseBinding" */ '@/views/user/set-my-information/car-binding/DriverLicenseBinding.vue'),
            meta: {
                title: '驾驶证绑定'
            }
        },
        {
            path: '/addMailingAddress',
            name: 'AddMailingAddress',
            component: () => import(/* webpackChunkName: "addMailingAddress" */ '@/views/user/set-my-information/mailing-address/AddMailingAddress.vue'),
            meta: {
                title: '添加邮寄地址'
            }
        },
        {
            path: '/mailingAddressList',
            name: 'MailingAddressList',
            component: () => import(/* webpackChunkName: "mailingAddressList" */ '@/views/user/set-my-information/mailing-address/MailingAddressList.vue'),
            meta: {
                title: '邮寄地址列表'
            }
        },
        {
            path: '/two-code',
            name: 'TwoCode',
            component: () => import(/* webpackChunkName: "mailingAddressList" */ '@/views/user/my-two-code/TwoCode.vue'),
            meta: {
                title: '个人推广二维码'
            }
        },
        {
            path: '/myHandlingList',
            name: 'MyHandlingList',
            component: () => import(/* webpackChunkName: "myHandlingList" */ '@/views/user/my-handling/MyHandlingList.vue'),
            meta: {
                title: '我的办件',
                keepAlive: true,
                requiresLogin: true,
            }
        },
        {
            path: '/myHandlingDetails/:tskNum',
            name: 'MyHandlingDetails',
            component: () => import(/* webpackChunkName: "myHandlingDetails" */ '@/views/user/my-handling/MyHandlingDetails.vue'),
            meta: {
                title: '我的办件详情'
            }
        },
        {
            path: '/myReservationList',
            name: 'MyReservationList',
            component: () => import(/* webpackChunkName: "myReservationList" */ '@/views/user/my-reservation/MyReservationList.vue'),
            meta: {
                title: '我的预约',
                keepAlive: true,
                requiresLogin: true,
            }
        },
        {
            path: '/myReservationDetails/:reservationGuid',
            name: 'MyReservationDetails',
            component: () => import(/* webpackChunkName: "myReservationDetails" */ '@/views/user/my-reservation/MyReservationDetails.vue'),
            meta: {
                title: '我的预约详情'
            }
        },
        {
            path: '/myAdvisoryList',
            name: 'MyAdvisoryList',
            component: () => import(/* webpackChunkName: "myAdvisoryList" */ '@/views/user/my-advisory/MyAdvisoryList.vue'),
            meta: {
                title: '我的咨询',
                keepAlive: true,
                requiresLogin: true,
            }
        },
        {
            path: '/myAdvisoryDetails/:advisoryGuid',
            name: 'MyAdvisoryDetails',
            component: () => import(/* webpackChunkName: "myAdvisoryDetails" */ '@/views/user/my-advisory/MyAdvisoryDetails.vue'),
            meta: {
                title: '我的咨询详情',
                requiresLogin: true,
            }
        },
        {
            path: '/myEvaluationList',
            name: 'MyEvaluationList',
            component: () => import(/* webpackChunkName: "myEvaluationList" */ '@/views/user/my-evaluation/MyEvaluationList.vue'),
            meta: {
                title: '我的评价',
                keepAlive: true,
                requiresLogin: true,
            }
        },
        {
            path: '/myEvaluationDetails/:evaluationGuid',
            name: 'MyEvaluationDetails',
            component: () => import(/* webpackChunkName: "myEvaluationDetails" */ '@/views/user/my-evaluation/MyEvaluationDetails.vue'),
            meta: {
                title: '我的评价详情'
            }
        },
        {
            path: '/myComplaintList',
            name: 'MyComplaintList',
            component: () => import(/* webpackChunkName: "myEvaluationList" */ '@/views/user/my-complaint/MyComplaintList.vue'),
            meta: {
                title: '我的投诉',
                keepAlive: true
            }
        },
        {
            path: '/myComplaintDetails/:complaintGuid',
            name: 'MyComplaintDetails',
            component: () => import(/* webpackChunkName: "myComplaintDetails" */ '@/views/user/my-complaint/MyComplaintDetails.vue'),
            meta: {
                title: '我的投诉详情'
            }
        },
        {
            path: '/myReportList',
            name: 'MyReportList',
            component: () => import(/* webpackChunkName: "myReportList" */ '@/views/user/my-report/MyReportList.vue'),
            meta: {
                title: '我的举报',
                keepAlive: true
            }
        },
        {
            path: '/myReportDetails/:reportGuid',
            name: 'MyReportDetails',
            component: () => import(/* webpackChunkName: "myReportDetails" */ '@/views/user/my-report/MyReportDetails.vue'),
            meta: {
                title: '我的举报详情'
            }
        },
        {
            path: '/myMessageList',
            name: 'myMessageList',
            component: () => import(/* webpackChunkName: "myMessageList" */ '@/views/user/my-messageCenter/MyMessageList.vue'),
            meta: {
                title: '消息中心',
                keepAlive: true,
                requiresLogin: true,
            }
        },
        // 查询中心
        {
            path: '/myHandlingScheduleQuery',
            name: 'MyHandlingScheduleQuery',
            component: () => import(/* webpackChunkName: "myHandlingScheduleQuery" */ '@/views/query/my-handling-schedule-query/MyHandlingScheduleQuery.vue'),
            meta: {
                title: '我的办件查询'
            }
        },
        {
            path: '/myHandlingScheduleQueryDetails',
            name: 'MyHandlingScheduleQueryDetails',
            component: () => import(/* webpackChunkName: "myHandlingScheduleQueryDetails" */ '@/views/query/my-handling-schedule-query/MyHandlingScheduleQueryDetails.vue'),
            meta: {
                title: '我的办件查询详情'
            }
        },
        // 咨询中心
        {
            path: '/advisoryList',
            name: 'AdvisoryList',
            components: {
                default: () => import(/* webpackChunkName: "advisoryList" */ '@/views/advisory/AdvisoryList.vue'),
                floor: NewFloor
            },
            meta: {
                title: '咨询列表',
                keepAlive: true
            }
        },
        {
            path: '/advisoryFrom',
            name: 'AdvisoryFrom',
            component: () => import(/* webpackChunkName: "advisoryFrom" */ '@/views/advisory/AdvisoryFrom.vue'),
            meta: {
                title: '咨询服务',
                requiresLogin: true,
            }
        },
        //应用中心
        {
            path: '/lostFoundList',
            name: 'LostFoundList',
            component: () => import(/* webpackChunkName: "lostFoundList" */ '@/views/application/lost-found/LostFoundList.vue'),
            meta: {
                title: '失物招领',
                keepAlive: true
            }
        },
        {
            path: '/lostFoundDetails',
            name: 'LostFoundDetails',
            component: () => import(/* webpackChunkName: "lostFoundDetails" */ '@/views/application/lost-found/LostFoundDetails.vue'),
            meta: {
                title: '失物招领详情'
            }
        },


        {
            path: '/searchNoticesList',
            name: 'SearchNoticesList',
            component: () => import(/* webpackChunkName: "searchNoticesList" */ '@/views/application/search-notices/SearchNoticesList.vue'),
            meta: {
                title: '寻人启事',
                keepAlive: true
            }
        },
        {
            path: '/searchNoticesDetails',
            name: 'SearchNoticesDetails',
            component: () => import(/* webpackChunkName: "searchNoticesDetails" */ '@/views/application/search-notices/SearchNoticesDetails.vue'),
            meta: {
                title: '寻人启事详情'
            }
        },
        {
            path: '/clueReport',
            name: 'ClueReport',
            component: () => import(/* webpackChunkName: "clueReport" */ '@/views/application/clue-report/ClueReport.vue'),
            meta: {
                title: '投诉举报',
                requiresLogin: true
            }
        },
        {
            path: '/complaint',
            name: 'Complaint',
            component: () => import(/* webpackChunkName: "complaint" */ '@/views/application/complaint/Complaint.vue'),
            meta: {
                title: '12389投诉'
            }
        },
        {
            path: '/matterList',
            name: 'MatterList',
            component: () => import(/* webpackChunkName: "matterList" */ '@/views/matter/list/MatterList.vue'),
                // floor: NewFloor
            meta: {
                title: '事项列表',
                keepAlive: true
            }
        },
        {
            path: '/matterListByGroup',
            name: 'MatterListByGroup',
            component: () => import(/* webpackChunkName: "matterListByGroup" */ '@/views/matter/list/MatterListByGroup.vue'),
            meta: {
                title: '事项列表分组',
            }
        },
        {
            path: '/standardMatter/:matterId',
            name: 'standardMatter',
            component: () => import(/* webpackChunkName: "matterList" */ '@/views/matter/declare/standard-matter/StandardMatter.vue'),
            meta: {
                title: '事项申报',
                keepAlive: true,
                requiresLogin: true
            }
        },
        {//监管定制化事项1：
            // 强制医疗所被强制医疗人员家属远程视频会见预约、拘留所被拘留人家属远程视频会见预约、
            // 看守所留所执行刑罚罪犯家属远程视频会见预约、公安强制隔离戒毒所戒毒人员家属远程视频会见预约、
            // 拘留所被拘留人家属现场会见预约、公安强制隔离戒毒所戒毒人员家属现场会见预约、强制医疗所被强制医疗人员家属现场会见预约、
            // 看守所留所执行刑罚罪犯家属现场会见预约
            path: '/supervise/family-appoint',
            name: 'FamilyAppointMatter',
            component: () => import('@/views/matter/declare/supervise-matter/FamilyAppointMatter.vue'),
            meta: {
                title: '事项申报',
                //keepAlive: true,
                requiresLogin: true
            }
        },
        {//监管定制化事项2：拘留所律师现场会见预约、看守所律师现场会见预约、公安强制隔离戒毒所律师会见预约、强制医疗所律师现场会见预约
            path: '/supervise/lawyer-appoint',
            name: 'LawyerAppointMatter',
            component: () => import('@/views/matter/declare/supervise-matter/LawyerAppointMatter.vue'),
            meta: {
                title: '事项申报',
                //keepAlive: true,
                requiresLogin: true
            }
        },
        {// 办案预约预约
            path: '/supervise/handle-appoint',
            name: 'HandleAppointMatter',
            component: () => import('@/views/matter/declare/supervise-matter/HandleAppointMatter.vue'),
            meta: {
                title: '事项申报',
                //keepAlive: true,
                requiresLogin: true
            }
        },
        {//出入境-定制化事项：境外人员护照遗失、损毁个人自主申报
            path: '/entryexit/Lost-damaged-passport',
            name: 'LostOrDamagedPassport',
            component: () => import('@/views/matter/declare/entryExit-matter/LostOrDamagedPassport.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//出入境-定制化事项：境外人员144小时免签个人自主申报
            path: '/entryexit/overseas-exemptions',
            name: 'Overseas144Exemptions',
            component: () => import('@/views/matter/declare/entryExit-matter/Overseas144Exemptions.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//出入境-定制化事项：境外人员口岸签证申报
            path: '/entryexit/overseas-port-visa',
            name: 'OverseasPersonnelPortVisa',
            component: () => import('@/views/matter/declare/entryExit-matter/OverseasPersonnelPortVisa.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        //户政旧事项表单
        // {//户政-出生登记-定制化事项：婚生子女登记户口
        //     path: '/hz/hj0001',
        //     name: 'RegistrationOfBirth',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/RegistrationOfBirth.vue'),
        //     meta: {
        //         title: '事项申报',
        //         // keepAlive: true,
        //         requiresLogin: true
        //     }
        // },
        // {//户政-出生登记-定制化事项：国（境）外出生子女登记户口 hj003
        //     path: '/hz/hj0003',
        //     name: 'HJ0003',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/HJ0003.vue'),
        //     meta: {
        //         title: '事项申报',
        //         // keepAlive: true,
        //         requiresLogin: true
        //     }
        // },
        // {//户政-出生登记-定制化事项：非婚生子女登记户口
        //     path: '/hz/hj0002',
        //     name: 'HzMattersOutWedlock',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/HzMattersOutWedlock.vue'),
        //     meta: {
        //         title: '事项申报',
        //         // keepAlive: true,
        //         requiresLogin: true
        //     }
        // },
        // {//户政出生类申报-定制化事项:父母双方服现役所生子女登记户口
        //     path: '/hz/hj0004',
        //     name: 'HzMattersMilitary',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/HzMattersMilitary.vue'),
        //     meta: {
        //         title: '事项申报',
        //         // keepAlive: true,
        //         requiresLogin: true
        //     }
        // },
        // {//户政出生类申报-定制化事项:父母双方为学校集体户所生子女登记户口
        //     path: '/hz/hj0005',
        //     name: 'HzMattersSchool',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/HzMattersSchool.vue'),
        //     meta: {
        //         title: '事项申报',
        //         // keepAlive: true,
        //         requiresLogin: true
        //     }
        // },
        // {//户政出生类申报-定制化事项:父母双方出国（境）定居所生子女登记户口
        //     path: '/hz/hj0006',
        //     name: 'HzMattersAbroad',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/HzMattersAbroad.vue'),
        //     meta: {
        //         title: '事项申报',
        //         // keepAlive: true,
        //         requiresLogin: true
        //     }
        // },
        // {//户政出生类申报-定制化事项:父母双亡人员所生子女登记户口
        //     path: '/hz/hj0007',
        //     name: 'HzMattersDeath',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/HzMattersDeath.vue'),
        //     meta: {
        //         title: '事项申报',
        //         // keepAlive: true,
        //         requiresLogin: true
        //     }
        // },
        // {// 户政定制化事项-合法收养登记户口
        //     path: '/hz/hj0009',
        //     name: 'AdoptByLaw',
        //     component: () => import('@/views/matter/declare/householdPolicy-matter/adopt-registration/AdoptByLaw.vue'),
        //     meta: {
        //         title: '事项申报',
        //         requiresLogin: true
        //     }
        // },



        // 外国人收养国内儿童注销户口
        {
            path: '/hz/hj0140',
            name:"HJ0103",
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-adoption-sy/HJ0103.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
                // keepAlive: true,
            }
        },
        // 义务兵、士官退出现役恢复户口
        {
            path: '/hz/hj0015',
            name: 'HJ0015',
            component: () => import('@/views/matter/declare/restore/HJ0015'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 【武汉】义务兵、士官退出现役恢复户口
        {
            path: '/hz/hj0016',
            name: 'HJ0016',
            component: () => import('@/views/matter/declare/restore/HJ0016'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 军队转业干部恢复户口
        {
            path: '/hz/hj0017',
            name: 'HJ0017',
            component: () => import('@/views/matter/declare/restore/HJ0017'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 现役干部转改文职人员恢复户口
        {
            path: '/hz/hj0018',
            name: 'HJ0018',
            component: () => import('@/views/matter/declare/restore/HJ0018'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 军队离退休干部（士官）恢复户口
        {
            path: '/hz/hj0019',
            name: 'HJ0019',
            component: () => import('@/views/matter/declare/restore/HJ0019'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 被军队退回、除名、开除军籍恢复户口
        {
            path: '/hz/hj0020',
            name: 'HJ0020',
            component: () => import('@/views/matter/declare/restore/HJ0020'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 法院宣告失踪重新出现恢复户口
        {
            path: '/hz/hj0025',
            name: 'HJ0025',
            component: () => import('@/views/matter/declare/restore/HJ0025'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 法院宣告死亡重新出现恢复户口
        {
            path: '/hz/hj0026',
            name: 'HJ0026',
            component: () => import('@/views/matter/declare/restore/HJ0026'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 未按规定申办户口迁移恢复户口
        {
            path: '/hz/hj0027',
            name: 'HJ0027',
            component: () => import('@/views/matter/declare/restore/HJ0027'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 户主变更
        {
            path: '/hz/hj0073',
            name: 'HJ0073',
            component: () => import('@/views/matter/declare/project-change/HJ0073'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 姓氏变更
        {
            path: '/hz/hj0074',
            name: 'HJ0074',
            component: () => import('@/views/matter/declare/project-change/HJ0074'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 名字变更
        {
            path: '/hz/hj0075',
            name: 'HJ0075',
            component: () => import('@/views/matter/declare/project-change/HJ0075'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 性别变更
        {
            path: '/hz/hj0076',
            name: 'HJ0076',
            component: () => import('@/views/matter/declare/project-change/HJ0076'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 民族变更
        {
            path: '/hz/hj0077',
            name: 'HJ0077',
            component: () => import('@/views/matter/declare/project-change/HJ0077'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 出生日期变更
        {
            path: '/hz/hj0078',
            name: 'HJ0078',
            component: () => import('@/views/matter/declare/project-change/HJ0078'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        // 公民身份证号码变更
        {
            path: '/hz/hj0080',
            name: 'HJ0080',
            component: () => import('@/views/matter/declare/project-change/HJ0080'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：31.县（市、区）、设区市市辖区内户口迁移；
            path: '/hz/hj0031',
            name: 'HJ0031',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0031.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },


        {//换领居民身份证
            path: '/hz/hj0152',
            name: 'HJ0152',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0152.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },


        {//【全省】婚生子女登记户口
            path: '/hz/hj0001',
            name: 'HJ0001',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0001.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//【全省】非婚生子女登记户口
            path: '/hz/hj0002',
            name: 'HJ0002',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0002.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//【全省】国（境）外出生子女登记户口
            path: '/hz/hj0003',
            name: 'HJ0003',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0003.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//【全省】 父母双方服现役所生子女登记户口
            path: '/hz/hj0004',
            name: 'HJ0004',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0004.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//【全省】父母双方为学校集体户所生子女登记户口
            path: '/hz/hj0005',
            name: 'HJ0005',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0005.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//【全省】父母双方出国（境）定居所生子女登记户口
            path: '/hz/hj0006',
            name: 'HJ0006',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0006.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//【全省】父母双亡人员所生子女登记户口
            path: '/hz/hj0007',
            name: 'HJ0032',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0007.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//【全省】合法收养登记户口
            path: '/hz/hj0009',
            name: 'HJ0032',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0009.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },




        {//户政-定制化事项-迁入登记：32
            path: '/hz/hj0032',
            name: 'HJ0032',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0032.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：33
            path: '/hz/hj0033',
            name: 'HJ0033',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0033.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：34
            path: '/hz/hj0034',
            name: 'HJ0034',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0034.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：35
            path: '/hz/hj0035',
            name: 'HJ0035',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0035.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：36
            path: '/hz/hj0036',
            name: 'HJ0036',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0036.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：37
            path: '/hz/hj0037',
            name: 'HJ0037',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0037.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：38.夫妻投靠及子女随迁落户；
            path: '/hz/hj0038',
            name: 'HJ0038',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0038.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：39
            path: '/hz/hj0039',
            name: 'HJ0039',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0039.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：40
            path: '/hz/hj0040',
            name: 'HJ0040',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0040.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：41.子女投靠父母落户；
            path: '/hz/hj0041',
            name: 'HJ0041',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0041.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：42
            path: '/hz/hj0042',
            name: 'HJ0042',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0042.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：43
            path: '/hz/hj0043',
            name: 'HJ0043',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0043.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：44
            path: '/hz/hj0044',
            name: 'HJ0044',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0044.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：45
            path: '/hz/hj0045',
            name: 'HJ0045',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0045.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：46.购买商品房落户；
            path: '/hz/hj0046',
            name: 'HJ0046',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0046.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：47
            path: '/hz/hj0047',
            name: 'HJ0047',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0047.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//户政-定制化事项-【武汉】非本市户籍人员在新城区、开发区落户
            path: '/hz/hj0116',
            name: 'HJ0116',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0116.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-【武汉】中专（技校）毕业生落户
            path: '/hz/hj0117',
            name: 'HJ0117',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0117.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-【武汉】学生（人才）集体户滞留人员落户
            path: '/hz/hj0118',
            name: 'HJ0118',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0118.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-【武汉】公务员、事业编制工作人员落户
            path: '/hz/hj0119',
            name: 'HJ0119',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0119.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },



        {//户政-定制化事项-迁入登记：48
            path: '/hz/hj0048',
            name: 'HJ0048',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0048.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：49
            path: '/hz/hj0049',
            name: 'HJ0049',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0049.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：51.大中专院校学生毕业落户；
            path: '/hz/hj0051',
            name: 'HJ0051',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0051.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：52
            path: '/hz/hj0052',
            name: 'HJ0052',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0052.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：53.在校大学生跨省（市）转学落户；
            path: '/hz/hj0053',
            name: 'HJ0053',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0053.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：54
            path: '/hz/hj0054',
            name: 'HJ0054',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0054.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：55
            path: '/hz/hj0055',
            name: 'HJ0055',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0055.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：56.引进人才落户
            path: '/hz/hj0056',
            name: 'HJ0056',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0056.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：57
            path: '/hz/hj0057',
            name: 'HJ0057',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0057.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：58
            path: '/hz/hj0058',
            name: 'HJ0058',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0058.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：59
            path: '/hz/hj0059',
            name: 'HJ0059',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0059.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：60
            path: '/hz/hj0060',
            name: 'HJ0060',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0060.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：61
            path: '/hz/hj0061',
            name: 'HJ0061',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0061.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：62
            path: '/hz/hj0062',
            name: 'HJ0062',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0062.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：63
            path: '/hz/hj0063',
            name: 'HJ0063',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0063.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：64
            path: '/hz/hj0064',
            name: 'HJ0064',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0064.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：65
            path: '/hz/hj0065',
            name: 'HJ0065',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0065.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：66.就业创业落户
            path: '/hz/hj0066',
            name: 'HJ0066',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0066.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：67
            path: '/hz/hj0067',
            name: 'HJ0067',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0067.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：68
            path: '/hz/hj0068',
            name: 'HJ0068',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0068.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：69
            path: '/hz/hj0069',
            name: 'HJ0069',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0069.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：70
            path: '/hz/hj0070',
            name: 'HJ0070',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0070.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：71.
            path: '/hz/hj0071',
            name: 'HJ0071',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0071.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：72.凭证迁移户口
            path: '/hz/hj0072',
            name: 'HJ0072',
            component: () => import('@/views/matter/declare/householdPolicy-matter/moveIn/HJ0072.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//户政-定制化事项-迁入登记：72.凭证迁移户口
            path: '/public-security/impawn',
            name: 'zaPawn',
            component: () => import('@/views/matter/declare/public-security/PawnLicence.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//治安-定制化事项-公章刻制
            path: '/public-security/cachet',
            name: 'zaCachet',
            component: () => import('@/views/matter/declare/public-security/CachetLicence.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//治安-定制化事项-旅馆行业
            path: '/public-security/hotel',
            name: 'zaHotel',
            component: () => import('@/views/matter/declare/public-security/HotelLicence.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//无犯罪证明
            path: '/xz/wfz0001',
            name: 'wfz0001',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0158.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//出入境临时住宿登记
            path: '/cr/cr0081',
            name: 'CR0081',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/CR0081.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },



        {// 无犯罪记录证明 非入职
            path: '/criminal-record',
            name: 'CriminalRecord',
            component: () => import('@/views/matter/declare/criminal-record/NotForJob.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 无犯罪记录证明  入职
            path: '/criminal-record-job',
            name: 'CriminalRecordJob',
            component: () => import('@/views/matter/declare/criminal-record/ForJob.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {//项目变更更正-【全省】出生日期变更（干部）
            path: '/hz/hj0079',
            name: 'HJ0079',
            component: () => import('@/views/matter/declare/project-change/HJ0079.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0081',
            name: 'HJ0081',
            component: () => import('@/views/matter/declare/project-change/HJ0081.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0082',
            name: 'HJ0082',
            component: () => import('@/views/matter/declare/project-change/HJ0082.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0083',
            name: 'HJ0083',
            component: () => import('@/views/matter/declare/project-change/HJ0083.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0084',
            name: 'HJ0084',
            component: () => import('@/views/matter/declare/project-change/HJ0084.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0085',
            name: 'HJ0085',
            component: () => import('@/views/matter/declare/project-change/HJ0085.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0086',
            name: 'HJ0086',
            component: () => import('@/views/matter/declare/project-change/HJ0086.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0087',
            name: 'HJ0087',
            component: () => import('@/views/matter/declare/project-change/HJ0087.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0088',
            name: 'HJ0088',
            component: () => import('@/views/matter/declare/project-change/HJ0088.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0089',
            name: 'HJ0089',
            component: () => import('@/views/matter/declare/project-change/HJ0089.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0090',
            name: 'HJ0090',
            component: () => import('@/views/matter/declare/project-change/HJ0090.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0091',
            name: 'HJ0091',
            component: () => import('@/views/matter/declare/project-change/HJ0091.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0092',
            name: 'HJ0092',
            component: () => import('@/views/matter/declare/project-change/HJ0092.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {
            path: '/hz/hj0093',
            name: 'HJ0093',
            component: () => import('@/views/matter/declare/project-change/HJ0093.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//证明出具-【全省】户口登记项目变更更正证明
            path: '/hz/hj0094',
            name: 'HJ0094',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0094.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//注销户口证明
            path: '/hz/hj0095',
            name: 'HJ0095',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0095.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//亲属关系证明
            path: '/hz/hj0096',
            name: 'HJ0096',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0096.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//【全省】户籍信息证明
            path: '/hz/hj0151',
            name: 'HJ0151',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0151.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//【全省】户口迁移情况证明
            path: '/hz/hj0150',
            name: 'HJ0150',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0150.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//异常户口注销（删除）证明
            path: '/hz/hj0097',
            name: 'HJ0097',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0097.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//换发《户口迁移证》（省外）
            path: '/hz/hj0104',
            name: 'HJ0104',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0104.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//补发《户口迁移证》（省外）
            path: '/hz/hj0105',
            name: 'HJ0105',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0105.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//换发《居民户口簿》
            path: '/hz/hj0106',
            name: 'HJ0106',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0106.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//补发《居民户口簿》
            path: '/hz/hj0107',
            name: 'HJ0107',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0107.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//流动人口暂住登记
            path: '/hz/hj0108',
            name: 'HJ0108',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0108.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//流动人口暂住登记
            path: '/hz/hj0110',
            name: 'HJ0110',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0110.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//流动人口暂住登记
            path: '/hz/hj0111',
            name: 'HJ0111',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0111.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//流动人口居住证首次申请
            path: '/hz/hj0109',
            name: 'HJ0109',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0109.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//武汉流动人口暂住登记
            path: '/hz/hj0155',
            name: 'HJ0155',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ0155.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//武汉居住证首次申领
            path: '/hz/hj0156',
            name: 'HJ0156',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ01561.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//武汉居住证首次申领
            path: '/hz/hj01561',
            name: 'HJ0156',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ01562.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//武汉补换领居住证
            path: '/hz/hj0157',
            name: 'HJ0157',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ01571.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },
        {//武汉补换领居住证
            path: '/hz/hj01571',
            name: 'HJ0157',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/HJ01572.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {//武汉专区道路施工
            path: '/zone/wh0001',
            name: 'WH0001',
            component: () => import('@/views/matter/declare/householdPolicy-matter/changecard/WH0001.vue'),
            meta: {
                title: '事项申报',
                // keepAlive: true,
                requiresLogin: true
            }
        },

        {// 法制行政审批-定制化事项（个人）
            path: '/xzsp/person',
            name: 'ApprovePerson',
            component: () => import('@/views/matter/declare/approve-matter/ApprovePerson.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 法制行政审批-定制化事项（个人）
            path: '/financial/business-premises',
            name: 'BusinessPremises',
            component: () => import('@/views/matter/declare/approve-matter/BusinessPremises.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 法制行政审批-定制化事项（个人）
            path: '/financial/security-facilities',
            name: 'BusinessPremises',
            component: () => import('@/views/matter/declare/approve-matter/BusinessPremises.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 法制行政审批-定制化事项（法人）
            path: '/xzsp/company',
            name: 'ApproveCompany',
            component: () => import('@/views/matter/declare/approve-matter/ApproveCompany.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-儿童福利机构登记户口
            path: '/hz/hj0008',
            name: 'ChildWelfareAgency',
            component: () => import('@/views/matter/declare/householdPolicy-matter/adopt-registration/ChildWelfareAgency.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-死亡注销户口
            path: '/hz/hj0011',
            name: 'DeathCertificate',
            component: () => import('@/views/matter/declare/householdPolicy-matter/logout-certificate/DeathCertificate.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-应征入伍注销户口
            path: '/hz/hj0012',
            name: 'Enlist',
            component: () => import('@/views/matter/declare/householdPolicy-matter/logout-certificate/Enlist.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-出国定居注销户口
            path: '/hz/hj0013',
            name: 'SettleAboard',
            component: () => import('@/views/matter/declare/householdPolicy-matter/logout-certificate/SettleAboard.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-赴港澳台定居注销户口
            path: '/hz/hj0014',
            name: 'SettleGangAoTai',
            component: () => import('@/views/matter/declare/householdPolicy-matter/logout-certificate/SettleGangAoTai.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-家庭立户
            path: '/hz/hj0132',
            name: 'HJ0132',
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-account-lh/HJ0132.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-城镇家庭立户
            path: '/hz/hj0138',
            name: 'HJ0138',
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-account-lh/HJ0138.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-农村家庭立户
            path: '/hz/hj0139',
            name: 'HJ0139',
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-account-lh/HJ0139.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-单位集体
            path: '/hz/hj0133',
            name: 'HJ0133',
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-account-lh/HJ0133.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-宗教场所
            path: '/hz/hj0134',
            name: 'HJ0134',
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-account-lh/HJ0134.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-大专院校
            path: '/hz/hj0135',
            name: 'HJ0135',
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-account-lh/HJ0135.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },
        {// 户政定制化事项-人才中心
            path: '/hz/hj0136',
            name: 'HJ0136',
            component: () => import('@/views/matter/declare/householdPolicy-matter/hz-account-lh/HJ0136.vue'),
            meta: {
                title: '事项申报',
                requiresLogin: true
            }
        },

        {
            path: '/zfb-matter/:pccId/:matterId/:userUid',
            name: 'MatterGuide1',
            component: () => import(/* webpackChunkName: "matterGuide" */ '@/views/matter/guide/MatterGuide1.vue'),
            meta: {
                title: '事项指南'
            }
        },

        {
            path: '/ehb-matter/:pccId/:matterId/:userUid',
            name: 'MatterGuide2',
            component: () => import(/* webpackChunkName: "matterGuide" */ '@/views/matter/guide/MatterGuide2.vue'),
            meta: {
                title: '事项指南'
            }
        },

        {
            path: '/HuberMap1/:queryUrl/:userUid',
            name: 'HuberMap1',
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/HuberMap1.vue'),
            meta: {
                title: '公安政务服务平台'
            }
        },


        {
            path: '/matterGuide/:pccId/:matterId',
            name: 'MatterGuide',
            component: () => import(/* webpackChunkName: "matterGuide" */ '@/views/matter/guide/MatterGuide.vue'),
            meta: {
                title: '事项指南'
            }
        },
        {
            path: '/reserveCity/:matterId/:matterName/:matterNum',
            name: 'ReserveCity',
            component: () => import(/* webpackChunkName: "reserveCity" */ '@/views/matter/reserve/ReserveCity.vue'),
            meta: {
                title: '事项预约',
                requiresLogin: true,
            }
        },
        {
            path: '/reserveList/:cityGuid/:townGuid/:matterId/:matterName',
            name: 'ReserveList',
            component: () => import(/* webpackChunkName: "ReserveList" */ '@/views/matter/reserve/ReserveList.vue'),
            meta: {
                title: '预约列表'
            }
        },
        {
            path: '/reserveSubmit/:dept_id/:dateTime/:dept_name/:matterId/:matterName',
            name: 'ReserveSubmit',
            component: () => import(/* webpackChunkName: "ReserveSubmit" */ '@/views/matter/reserve/ReserveSubmit.vue'),
            meta: {
                title: '预约信息'
            }
        },

        {
            path: '/unpaid',
            name: 'Unpaid',
            component: () => import(/* webpackChunkName: "unpaid" */ '@/views/user/payment/Unpaid.vue'),
            meta: {
                title: '待支付'
            }
        },
        {
            path: '/submitPayment',
            name: 'SubmitPayment',
            component: () => import(/* webpackChunkName: "unpaid" */ '@/views/user/payment/SubmitPayment.vue'),
            meta: {
                title: '提交支付'
            }
        },
        {
            path: '/paymentSuccess',
            name: 'PaymentSuccess',
            component: () => import(/* webpackChunkName: "unpaid" */ '@/views/user/payment/PaymentSuccess.vue'),
            meta: {
                title: '支付成功'
            }
        },
        {
            path: '/announcementList',
            name: 'AnnouncementList',
            component: () => import(/* webpackChunkName: "announcementList" */ '@/views/announcement/AnnouncementList'),
            meta: {
                title: '公示公告'
            }
        },
        {
            path: '/announcementDetails',
            name: 'AnnouncementDetails',
            component: () => import(/* webpackChunkName: "announcementList" */ '@/views/announcement/AnnouncementDetails'),
            meta: {
                title: '公告详情'
            }
        },
        {//电子证照
            path: '/electronicCertificate',
            name: 'ElectronicCertificate',
            meta: {title: '电子证照'},
            component: () => import(/* webpackChunkName: "electronicCertificate" */ '@/views/user/electronicCertificate/ElectronicCertificate.vue'),
        },
        {//电子证照--驾驶证
            path: '/driverLicense',
            name: 'DriverLicense',
            meta: {
                title: '驾驶证',
                requiresLogin: true,
                requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "driverLicense" */ '@/views/user/electronicCertificate/DriverLicense.vue'),
        },
        {//电子证照--驾驶证(扫码列表）
            path: '/qrdriverLicense/:token',
            name: 'ElectronicDriverLicense',
            meta: {title: '电子驾驶证', requiresLogin: true},
            component: () => import(/* webpackChunkName: "qrdriverLicense" */ '@/views/electronic/electronicDriverLicense/ElectronicDriverLicense.vue'),
        },
        {//电子证照--身份证
            path: '/idCard',
            name: 'IdCard',
            meta: {
                title: '身份证',
                requiresLogin: true,
                requiresAuth: true,
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "idCard" */ '@/views/user/electronicCertificate/IdCard.vue'),
        },
        {//电子证照--身份证(扫码列表）
            path: '/qridcard/:token',
            name: 'ElectronicIdCard',
            meta: {
                title: '电子身份证',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "qridcard" */ '@/views/electronic/electronicIdCard/ElectronicIdCard.vue'),
        },
        {//电子证照--居住证
            path: '/residencePermit',
            name: 'ResidencePermit',
            meta: {
                title: '居住证',
                requiresLogin: true,
                requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "residencePermit" */ '@/views/user/electronicCertificate/ResidencePermit.vue'),
        },
        {//电子证照--无犯罪记录证明(扫码列表）
            path: '/qrCriminalRecord/:token',
            name: 'CriminalRecord',
            meta: {
                title: '无犯罪记录证明',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "qrCriminalRecord" */ '@/views/electronic/criminalRecord/CriminalRecord.vue'),
        },
        {//电子证照--居住证(扫码列表）
            path: '/qrresidence/:token',
            name: 'ElectronicResidencePermit',
            meta: {
                title: '电子居住证',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "ElectronicResidencePermit" */ '@/views/electronic/electronicResidencePermit/ElectronicResidencePermit.vue'),
        },
        {//电子证照--武汉电子居住证
            path: '/Mindaugas',
            name: 'Mindaugas',
            meta: {
                title: '武汉电子居住证',
                requiresLogin: true,
                requiresAuth: true,
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "idCard" */ '@/views/user/electronicCertificate/Mindaugas.vue'),
        },
        {//电子证照--武汉居住证(扫码列表）
            path: '/whResidencePermit/:token',
            name: 'whResidencePermit',
            meta: {
                title: '武汉电子居住证',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "whResidencePermit" */ '@/views/electronic/whResidencePermit/whResidencePermit.vue'),
        },
        { //电子证照--行驶证第一页
            path: '/drivingLicense',
            name: 'DrivingLicense',
            component: () => import(/* webpackChunkName: "setMyInformation" */ '@/views/user/electronicCertificate/DrivingLicense.vue'),
            meta: {
                title: '电子行驶证',
                requiresLogin: true,
                requiresAuth: true,
            }
        },
        {//电子证照--行驶证
            path: '/vehicleLicense',
            name: 'VehicleLicense',
            meta: {title: '行驶证', requiresLogin: true,},
            component: () => import(/* webpackChunkName: "vehicleLicense" */ '@/views/user/electronicCertificate/VehicleLicense.vue'),
        },
        {//电子证照--行驶证(扫码列表）
            path: '/qrdriving/:token',
            name: 'ElectronicDrivingLicense',
            meta: {
                title: '电子行驶证',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "ElectronicDrivingLicense" */ '@/views/electronic/electronicDrivingLicense/ElectronicDrivingLicense.vue'),
        },
        {//电子证照--护照
            path: '/protection',
            name: 'Protection',
            meta: {
                title: '护照',
                requiresLogin: true,
                requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "vehicleLicense" */ '@/views/user/electronicCertificate/Protection.vue'),
        },
        {//电子证照--护照(扫码列表）
            path: '/qrprotection/:token',
            name: 'ElectronicProtection',
            meta: {
                title: '电子护照',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "ElectronicProtection" */ '@/views/electronic/electronicProtection/ElectronicProtection.vue'),
        },
        {//电子证照--港澳通行证
            path: '/HKMPermit',
            name: 'HKMPermit',
            meta: {
                title: '港澳通行证',
                requiresLogin: true,
                requiresAuth:true
            },
            component: () => import(/* webpackChunkName: "HKMPermit" */ '@/views/user/electronicCertificate/HKMPermit.vue'),
        },
        {//电子证照--港澳通行证(扫码列表）
            path: '/qrhkm/:token',
            name: 'ElectronicHKMPermit',
            meta: {
                title: '电子护照',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "ElectronicHKMPermit" */ '@/views/electronic/electronicHKMPermit/ElectronicHKMPermit.vue'),
        },
        {//电子证照--台湾通行证
            path: '/TWPermit',
            name: 'TWPermit',
            meta: {
                title: '台湾通行证', requiresLogin: true,
                requiresAuth:true
            },
            component: () => import(/* webpackChunkName: "TWPermit" */ '@/views/user/electronicCertificate/TWPermit.vue'),
        },
        {//电子证照--台湾通行证(扫码列表）
            path: '/qrtw/:token',
            name: 'ElectronicTWPermit',
            meta: {
                title: '电子护照',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "ElectronicTWPermit" */ '@/views/electronic/electronicTWPermit/ElectronicTWPermit.vue'),
        },

        {//湖北社采
            path: '/HuberMap',
            name: 'HuberMap',
            meta: {title: '湖北社采'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/HuberMap.vue'),
        },

        {//电子证照--户口簿
            path: '/residenceBooklet',
            name: 'ResidenceBooklet',
            meta: {
                title: '户口簿', requiresLogin: true,
                requiresAuth:true
            },
            component: () => import(/* webpackChunkName: "ResidenceBooklet" */ '@/views/user/electronicCertificate/ResidenceBooklet.vue'),
        },
        {//电子证照--户口薄(扫码列表）
            path: '/qrbooklet/:token',
            name: 'ElectronicResidenceBooklet',
            meta: {
                title: '电子户口薄',
                // requiresLogin: true
                // keepAlive: true
            },
            component: () => import(/* webpackChunkName: "ElectronicResidenceBooklet" */ '@/views/electronic/electronicResidenceBooklet/ElectronicResidenceBooklet.vue'),
        },
        {//电子证照--临时乘机证明
            path: '/flightCertificate',
            name: 'FlightCertificate',
            meta: {title: '临时乘机证明'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/user/electronicCertificate/FlightCertificate.vue'),
        },
        // {
        //   path: '/inquiry',
        //   name: 'Inquiry',
        //   meta: { title: '临时乘机证明' },
        //   component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/user/inquiry/Inquiry.vue'),
        // }
        {//身份证进度查询
            path: '/idquery',
            name: 'IDQuery',
            meta: {
                title: '身份证进度查询',
                requiresLogin: true
                ,requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/IDQuery.vue'),
        },

        // {//新生儿出生医学证明查询
        //     path: '/birth',
        //     name: 'Birth',
        //     meta: {title: '新生儿出生医学证明查询'
        //         // , requiresLogin: true
        //     },
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/Birth.vue'),
        // },
        //
        // {//涉外婚姻登记信息核验服务
        //     path: '/registration',
        //     name: 'Registration',
        //     meta: {title: '涉外婚姻登记信息核验服务',
        //         requiresLogin: true},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/Registration.vue'),
        // },

        // {//疫苗接种信息查询
        //     path: '/inoculate',
        //     name: 'Inoculate',
        //     meta: {title: '疫苗接种信息查询'},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/Inoculate.vue'),
        // },
        //
        // {//新生儿出生日期查询
        //     path: '/birthDate',
        //     name: 'BirthDate',
        //     meta: {title: '新生儿出生日期查询',
        //         requiresLogin: true},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/BirthDate.vue'),
        // },
        //
        // {//火化信息查询
        //     path: '/funeral',
        //     name: 'Funeral',
        //     meta: {title: '火化信息查询',
        //         requiresLogin: true},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/Funeral.vue'),
        // },

        {//居住证进度查询
            path: '/resquery',
            name: 'ResQuery',
            meta: {title: '居住证进度查询',
                requiresLogin: true
                ,requiresAuth: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/ResQuery.vue'),
        },
        {//警情查询查询
            path: '/polinfoquery',
            name: 'PolInfoQuery',
            meta: {title: '警情信息查询', requiresLogin: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/PolInfoQuery.vue'),
        },
        {//全国异地证办理查询
            path: '/strangerquery',
            name: 'StrangerQuery',
            meta: {title: '全国异地证办理查询',
                requiresLogin: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/StrangerQuery.vue'),
        },
        {//港澳台居住证办理进度查询
            path: '/hkmquery',
            name: 'HKMQuery',
            meta: {title: '港澳台居住证办理进度查询',
                requiresLogin: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/HKMQuery.vue'),
        },
        {//我要查询
            path: '/searchList',
            name: 'SearchList',
            meta: {title: '查询中心'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/searchServer/SearchList.vue'),
        },
        {//事项中心
            path: '/mattersCenter',
            name: 'mattersCenter',
            meta: {title: '事项中心'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/mattersCenter/mattersCenter.vue'),
        },
        {//堵路移车
            path: '/moveCar',
            name: 'MoveCar',
            meta: {title: '堵路移车', requiresLogin: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/application/move-car/MoveCar.vue'),
        },
        {//热门应用
            path: '/hotApply',
            name: 'hotApply',
            meta: {title: '热门应用'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/hotApply.vue'),
        },
        {//电子乘机证明
            path: '/rideCertificate',
            name: 'RideCertificate',
            meta: {title: '电子乘机证明'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/RideCertificate.vue'),
        },
        {//微信直通车
            path: '/wechatTrain',
            name: 'WeChatTrain',
            meta: {title: '警方矩阵'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/wechatTrain/WeChatTrain.vue'),
        },
        {//执法公开
            path: '/LawMap',
            name: 'LawMap',
            meta: {title: '执法公开'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/LawMap.vue'),
        },
        {//便民开锁
            path: '/easyLock',
            name: 'EasyLock',
            meta: {title: '便民开锁'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/EasyLock.vue'),
        },
        {//身边警局
            path: '/policeMap',
            name: 'PoliceMap',
            meta: {title: '身边警局'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/PoliceMap.vue'),
        },
        {//印章管理平台
            path: '/sealManagement',
            name: 'sealManagement',
            meta: {title: '印章管理平台'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/sealManagement.vue'),
        },
        {//鄂汇拍
            path: '/eHp',
            name: 'eHp',
            meta: {title: '鄂汇拍'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/eHp.vue'),
        },
        {//湖北省反诈中心
            path: '/antiFraud',
            name: 'antiFraud',
            meta: {title: '湖北省反诈中心'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/hotApply/AntiFraud.vue'),
        },
        {//户口办理进度
            path: '/household',
            name: 'Household',
            meta: {title: '户口办理进度查询'
                // ,requiresLogin: true,requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/Household.vue'),
        },
        {//出入境证件办理进度
            path: '/entry-exit',
            name: 'Entry-exit',
            meta: {title: '出入境证件办理进度查询',requiresLogin: true,requiresAuth: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/Entry-exit.vue'),

        },
        {//重名查询
            path: '/renameQuery',
            name: 'RenameQuery',
            meta: {title: '重名查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/RenameQuery.vue'),
        },

        {//政务网办件查询所属派出所
            path: '/szfBaseQuery',
            name: 'szfBaseQuery',
            meta: {title: '公安办件数据查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/SzfBaseQuery.vue'),
        },

        {//生僻字查询
            path: '/rareQuery',
            name: 'RareQuery',
            meta: {title: '冷僻字查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/RareQuery.vue'),
        },
        {//EMS查询
            path: '/eMSQuery',
            name: 'EMSQuery',
            meta: {title: 'EMS查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/EMSQuery.vue'),
        },
        {//居住登记状态进度查询
            path: '/resigQuery',
            name: 'ResigQuery',
            meta: {title: '居住登记状态进度查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/ResigQuery.vue'),
        },
        {//签注查询
            path: '/signatureQuery',
            name: 'SignatureQuery',
            meta: {title: '签注查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/SignatureQuery.vue'),
        },
        // {//港澳台居住证办证进度查询
        //     path: '/permitQuery',
        //     name: 'PermitQuery',
        //     meta: {title: '港澳居住证办证进度查询',requiresLogin: true,requiresAuth: true},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/PermitQuery.vue'),
        // },
        // {//港澳台居住证办证进度查询
        //     path: '/TWQuery',
        //     name: 'TWQuery',
        //     meta: {title: '台湾居住证办证进度查询',requiresLogin: true,requiresAuth: true},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/TWQuery.vue'),
        // },
        {//出入境记录
            path: '/recordQuery',
            name: 'RecordQuery',
            meta: {title: '出入境记录',requiresLogin: true,requiresAuth: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/RecordQuery.vue'),
        },
        {//证件查询
            path: '/certificatesQuery',
            name: 'CertificatesQuery',
            meta: {title: '证件查询',requiresLogin: true,requiresAuth: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/CertificatesQuery.vue'),
        },
        {//证件查询
            path: '/contactQuery',
            name: 'ContactQuery',
            meta: {title: '中国驻外使馆联系方式查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/ContactQuery.vue'),
        },
        {//驾驶证记分查询
            path: '/licenseQuery',
            name: 'LicenseQuery',
            meta: {title: '驾驶证记分查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/LicenseQuery.vue'),
        },
        {//机动车违法查询
            path: '/lllegalQuery',
            name: 'LllegalQuery',
            meta: {title: '机动车违法查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/LllegalQuery.vue'),
        },
        {//公章刻制名录
            path: '/sealQuery',
            name: 'SealQuery',
            meta: {title: '公章刻制名录'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/SealQuery.vue'),
        },
        // 乘车备案
        {
            path: '/ridingRecord',
            name: 'ridingRecord',
            component:() => import('@/views/ridingRecord/RidingRecord.vue'),
            meta: {
                title:'乘车备案',
                requiresLogin: true // 添加该字段，表示进入这个路由是需要登录的
                // requiresAuth:true
            }
        },
        {//定位备案
            path: '/mapRecord',
            name: 'mapRecord',
            component:() => import('@/views/ridingRecord/MapRecord.vue'),
            meta: {
                title: '定位备案'
                // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                // isConfirm: true
            }
        },
        {//车辆备案
            path: '/carRecord',
            name: 'car',
            component:() => import('@/views/ridingRecord/CarRecord.vue'),
            meta: {
                title:'车辆备案'
                // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                // isConfirm: true
            }
        },
        {//开锁业从业单位 人名名录查询
            path: '/unlockQuery',
            name: 'UnlockQuery',
            meta: {title: '开锁业从业单位 人名名录查询'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/UnlockQuery.vue'),
        },
        {//全国异地证办证进度查询
            path: '/differentQuery',
            name: 'DifferentQuery',
            meta: {title: '全国异地证办证进度查询',requiresLogin: true,requiresAuth: true},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/DifferentQuery.vue'),
        },
        // {//出入境签注
        //     path: '/endorsement',
        //     name: 'ImmigrationEndorsement',
        //     meta: {title: '出入境签注查询',requiresLogin: true,requiresAuth: true},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/ImmigrationEndorsement.vue'),
        // },
        // {//出入境证件
        //     path: '/exitdocuments',
        //     name: 'EntryAndExitDocuments',
        //     meta: {title: '出入境证件查询',requiresLogin: true,requiresAuth: true},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/EntryAndExitDocuments.vue'),
        // },

        // {//港澳台居民居住证受理点查询
        //     path: '/acceptanceQuery',
        //     name: 'AcceptanceQuery',
        //     meta: {title: '港澳台居民居住证受理点查询'},
        //     component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/query/AcceptanceQuery.vue'),
        // },
        {//智能搜索
            path: '/serviceList',
            name: 'ServiceList',
            meta: {title: '智能搜索'},
            component: () => import(/* webpackChunkName: "FlightCertificate" */ '@/views/searchService/ServiceList.vue'),
        },
        // {
        //     path: '/login1',
        //     name: 'Login1',
        //     component: () => import(/* webpackChunkName: "login1" */ '@/views/join/login/LoginV2.vue'),
        //     meta: {
        //         title: '登录'
        //     }
        // },
        // {
        //     path: '/registered1',
        //     name: 'Registered1',
        //     component: () => import(/* webpackChunkName: "registered1" */ '@/views/join/registered/RegisteredValid.vue'),
        //     meta: {
        //         title: '注册'
        //     }
        // },
        // {
        //     path: '/forgetPassword1',
        //     name: 'ForgetPassword1',
        //     component: () => import(/* webpackChunkName: "forgetPassword1" */ '@/views/join/forget-password-new/StepOne.vue'),
        //     meta: {
        //         title: '忘记密码'
        //     }
        // },
        // {
        //     path: '/forgetPassword2',
        //     name: 'ForgetPassword2',
        //     component: () => import(/* webpackChunkName: "forgetPassword1" */ '@/views/join/forget-password/StepTwo.vue'),
        //     meta: {
        //         title: '忘记密码'
        //     }
        // },
        // {
        //     path: '/forgetPassword3',
        //     name: 'ForgetPassword3',
        //     component: () => import(/* webpackChunkName: "forgetPassword1" */ '@/views/join/forget-password-new/StepThree.vue'),
        //     meta: {
        //         title: '忘记密码'
        //     }
        // },
        {
            path: '/qrsearch',
            name: 'qrsearch',
            component: () => import(/* webpackChunkName: "forgetPassword1" */ '@/views/qrsearch/qrsearch.vue'),
            meta: {
                title: ''
            }
        },
        {
            path: '/sealquery',
            name: 'SealQuery',
            component: () => import(/* webpackChunkName: "forgetPassword1" */ '@/views/query/SealQuery.vue'),
            meta: {
                title: ''
            }
        },
        //暂时隐藏，需改图标重新设计，app扫码下载页面
        {
            path: '/appdownload',
            name: 'appdownload',
            component: () => import(/* webpackChunkName: "appdownload" */ '@/views/appDownload/appdownload.vue'),
            meta: {
                title: 'app扫描'
            }
        },
        //二维码推广，生成二维码页面
        {
            path: '/extensioncode',
            name: 'extensionCode',
            component: () => import(/* webpackChunkName: "appdownload" */ '@/views/index/extensionCode.vue'),
            meta: {
                title: '二维码推广'
            }
        },
        //新的注册登录qiux2019-11-01
        //登录注册之前的页面
        {
            path: '/sign-up/guide',
            name: 'guide',
            component: () => import(/* webpackChunkName: "guide" */ '@/views/signUp/Index.vue'),
            meta: {
                title: '先导页'
            }
        },
        { //注册
            path: '/sign-up/register',
            name: 'register',
            component: () => import(/* webpackChunkName: "register" */ '@/views/signUp/register/Register.vue'),
            meta: {
                title: '注册'
            }
        },
        { //注册
            path: '/sign-up/registerNew',
            name: 'RegisterNew',
            component: () => import(/* webpackChunkName: "RegisterNew" */ '@/views/signUp/register/RegisterNew.vue'),
            meta: {
                title: '注册'
            }
        },
        { //注册-详细
            path: '/sign-up/register/det',
            name: 'registerdet',
            component: () => import(/* webpackChunkName: "registerdet" */ '@/views/signUp/register/RegisterDet.vue'),
            meta: {
                title: '注册'
            }
        },

        { //支付宝注册
            path: '/sign-up/register/zfb',
            name: 'registerZfb',
            component: () => import(/* webpackChunkName: "register" */ '@/views/signUp/register-zfb/Register.vue'),
            meta: {
                title: '注册'
            }
        },
        { //支付宝注册-详细
            path: '/sign-up/register-zfb/det',
            name: 'registerdetZfb',
            component: () => import(/* webpackChunkName: "registerdet" */ '@/views/signUp/register-zfb/RegisterDet.vue'),
            meta: {
                title: '注册'
            }
        },

        { //注册-法人注册
          path: '/legal-person-register/index',
          name: 'legalPersonRegister',
          component: () => import(/* webpackChunkName: "legalPersonRegister" */ '@/views/signUp/legalPersonRegister/register.vue'),
          meta: {
            title: '法人注册'
          }
        },
        { //注册-法人注册详情（校验未成功）
          path: '/legal-person-register/register-det',
          name: 'registerDet',
          component: () => import(/* webpackChunkName: "legalPersonRegister" */ '@/views/signUp/legalPersonRegister/register-det.vue'),
          meta: {
            title: '法人注册'
          }
        },
        { //注册-法人注册详情-第二步
          path: '/legal-person-register/register-2',
          name: 'register-2',
          component: () => import(/* webpackChunkName: "legalPersonRegister" */ '@/views/signUp/legalPersonRegister/register-2.vue'),
          meta: {
            title: '法人注册'
          }
        },
        { //注册-法人注册详情-第三步
          path: '/legal-person-register/register-3',
          name: 'register-3',
          component: () => import(/* webpackChunkName: "legalPersonRegister" */ '@/views/signUp/legalPersonRegister/register-3.vue'),
          meta: {
            title: '法人注册'
          }
        },
        {
            path: '/sign-up/login',
            name: 'LoginNew',
            component: () => import(/* webpackChunkName: "login" */ '@/views/signUp/landing/Login.vue'),
            meta: {
                title: '登录'
            }
        },
        {
            path: '/new/login',
            name: 'LoginV2',
            component: () => import(/* webpackChunkName: "login" */ '@/views/signUp/landing/LoginV2.vue'),
            meta: {
                title: '登录'
            }
        },

        {
            path: '/new/login/zfb',
            name: 'LoginV3',
            component: () => import(/* webpackChunkName: "login" */ '@/views/signUp/landing/LoginV3.vue'),
            meta: {
                title: '支付宝登录'
            }
        },

        {
            path: '/sign-up/forget-password',
            name: 'forgetpassword',
            component: () => import(/* webpackChunkName: "forgetpassword" */'@/views/signUp/forget-password/ForgetPassword.vue'),
            meta: {
                title: '忘记密码'
            }
        },
        {
            path: '/sign-up/forget-password/det',
            name: 'ForgetPasswordDet',
            component: () => import(/* webpackChunkName: "ForgetPasswordDet" */'@/views/signUp/forget-password/ForgetPasswordDet.vue'),
            meta: {
                title: '忘记密码'
            }
        },
        {
            path: '/sign-up/account-appeal',
            name: 'AccountAppeal',
            component: () => import(/* webpackChunkName: "AccountAppeal" */ '@/views/signUp/account-appeal/AccountAppeal.vue'),
            meta: {
                title: '账号申诉'
            }
        },
        {
            path: '/sign-up/account-appeal/black',
            name: 'AccountBlack',
            component: () => import(/* webpackChunkName: "AccountAppeal" */ '@/views/signUp/account-appeal/AccountAppealBlack.vue'),
            meta: {
                title: '二次核验'
            }
        },
        {
            path: '/sign-up/account-appeal/id',
            name: 'AccountAppealID',
            component: () => import(/* webpackChunkName: "AccountAppealID" */ '@/views/signUp/account-appeal/AccountAppealIdCard.vue'),
            meta: {
                title: '账号申诉-身份证被注册'
            }
        },
        {
            path: '/sign-up/account-appeal/tel',
            name: 'AccountAppealTel',
            component: () => import(/* webpackChunkName: "AccountAppealTel" */ '@/views/signUp/account-appeal/AccountAppealTel.vue'),
            meta: {
                title: '账号申诉-手机号被注册'
            }
        },
        //Tolerance我的容缺受理
        {
            path: '/user/my-tolerance',
            name: 'Tolerance',
            component: () => import(/* webpackChunkName: "Tolerance" */ '@/views/user/my-tolerance/Tolerance.vue'),
            meta: {
                title: '我的容缺受理',
                requiresLogin: true,
            }
        },
        //Tolerance我的容缺受理描述
        {
            path: '/user/my-tolerance/form-description/:status/:guid',
            name: 'ToleranceDescription',
            component: () => import(/* webpackChunkName: "ToleranceDescription" */ '@/views/user/my-tolerance/ToleranceDescription.vue'),
            meta: {
                title: '我的容缺受理',
                requiresLogin: true,
            }
        },
        // APP 退出回调页面
        {
            path: '/app/login-out',
            name: 'appLoginOut',
            component: () => import(/* webpackChunkName: "appLoginOut" */ '@/views/app/AppLoginOut.vue'),
            meta: {
                title: '退出',
            }
        },
        // APP 退出回调页面
        {
            path: '/app/login',
            name: 'appLogin',
            component: () => import(/* webpackChunkName: "appLogin" */ '@/views/app/AppLogin.vue'),
            meta: {
                title: '退出',
            }
        },
        // 驾驶人信息
        {
            path: '/driverView',
            name: 'driverView',
            component: () => import(/* webpackChunkName: "appLogin" */ '@/views/driver/driverView.vue'),
            meta: {
                title: '驾驶人信息',
            }
        },
        // 车辆信息
        {
            path: '/vehicleDetail/ :carNum/ :isIllegal',
            name: 'vehicleDetail',
            component: () => import(/* webpackChunkName: "appLogin" */ '@/views/driver/vehicleDetail.vue'),
            meta: {
                title: '车辆信息',
            }
        },
        //
        {
            path: '/public/sso/:token',
            name: 'pt',
            component: () => import(/* webpackChunkName: "appLogin" */ '@/views/signUp/sso/Login.vue'),
            meta: {
                title: '单点登录',
            }
        },
        {
          path: '/ytj-login/:guid',
          name: 'ytjLogin',
          component: () => import(/* webpackChunkName: "appLogin" */ '@/views/ytj/YtjLogin.vue'),
          meta: {
            title: '一体机扫码登录',
          }
        },
        {
            path: '/declare/success/:tskNum',
            name: 'success',
            component: () => import(/* webpackChunkName: "appLogin" */ '@/views/matter/declare/criminal-record/success'),
            meta: {
                title: '申报成功跳转滴滴优惠券',
            }
        },
        //厅长信箱
        {
            path: '/letter',
            name: 'letter',
            component: () => import(/* webpackChunkName: "letter" */ '@/views/letter/index'),
            meta: {
                title: '厅长信箱',
            }
        },
        //厅长信箱 - 我的回复
        {
            path: '/replay',
            name: 'replay',
            component: () => import(/* webpackChunkName: "replay" */ '@/views/letter/replay'),
            meta: {
                title: '回复查询',
            }
        },//厅长信箱 - 详情
        {
            path: '/replay-det',
            name: 'replayDet',
            component: () => import(/* webpackChunkName: "replay" */ '@/views/letter/replay-det'),
            meta: {
                title: '查看详情',
            }
        },
        {
            path: '/Information',
            name: 'Information',
            component: () => import(/* webpackChunkName: "Information" */ '@/views/letter/Information'),
            meta: {
                title: '申报',
                requiresLogin: true,
            }
        },
        {
            path: '/ReportViolations',
            name: 'ReportViolations',
            component: () => import(/* webpackChunkName: "ReportViolations" */ '@/views/letter/ReportViolations'),
            meta: {
                title: '民辅警违纪举报',
                requiresLogin: true,
            }
        },
        {
            path: '/ReportClues',
            name: 'ReportClues',
            component: () => import(/* webpackChunkName: "ReportClues" */ '@/views/letter/ReportClues'),
            meta: {
                title: '违法犯罪线索举报',
                requiresLogin: true,
            }
        },
    ]
})


